export class PromiseQueue {
  private activePromise: Promise<any> | null = null;
  private nextPromise: (() => Promise<any>) | null = null;

  async add(promiseFn: () => Promise<any>) {
    this.nextPromise = promiseFn;

    if (!this.activePromise) {
      await this.runNext();
    }
  }

  private async runNext() {
    if (this.nextPromise) {
      const currentPromise = this.nextPromise;
      this.nextPromise = null;
      this.activePromise = currentPromise();

      try {
        await this.activePromise;
      } catch (error) {
        console.error("Promise failed", error);
      }

      this.activePromise = null;
      await this.runNext();
    }
  }
}
